import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { take } from 'rxjs/operators';
import { getDefaultPageable, getPageableAsParams, Page, Pageable } from '../models/page.model';
import { IBank } from "../models/bank.model";

@Injectable({
  providedIn: 'root',
})
export class BankService {
  private baseUrl = 'operation/v1/bank';

  constructor(private http: HttpClient) {}

  createBank(bankDto: IBank, logo: File): Observable<IBank> {
    const formData: FormData = new FormData();
    formData.append('logo', logo, logo.name);
    formData.append('bank', JSON.stringify(bankDto));
    return this.http.post<IBank>(this.baseUrl, formData).pipe(take(1));
  }

  updateLogo(id: string, logo: File): Observable<IBank> {
    const formData = new FormData();
    formData.append('file', logo); // Changed 'logo' to 'file' to match backend @RequestPart
    formData.append('id', id);

    return this.http.post<IBank>(
      `${this.baseUrl}/logo`,
      formData,
      { headers: {} } // Let Angular set the correct Content-Type with boundary
    ).pipe(take(1));
  }

  updateBank(id: string, bankDto: IBank): Observable<IBank> {
    return this.http.put<IBank>(`${this.baseUrl}/${id}`, bankDto).pipe(take(1));
  }

  deleteBank(id: string): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/${id}`).pipe(take(1));
  }

  getBankById(id: string): Observable<IBank> {
    return this.http.get<IBank>(`${this.baseUrl}/${id}`).pipe(take(1));
  }

  getAllBanks(pageable: Pageable = getDefaultPageable()): Observable<Page<IBank>> {
    const params = getPageableAsParams(pageable);
    return this.http.get<Page<IBank>>(this.baseUrl, { params }).pipe(take(1));
  }

  /**
   * Search counterparts by name and country of origin
   * @param name bank's name
   * @param country bank's country
   * @param pageable the pageable
   * @return banks that meet criteria
   */
  searchBanksByNameAndCountry(name: string, country: string, pageable: Pageable = getDefaultPageable()): Observable<Page<IBank>> {
    let params = getPageableAsParams(pageable).append('name', name);
    params = params.append('country', country);
    return this.http.get<Page<IBank>>(`${this.baseUrl}/searchByNameAndCountry`, { params }).pipe(take(1));
  }
}
